import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';

const styles = css``;

function ThankYou({ page }) {
  return (
    <PageWrapper className={styles}>
      <PageHelmet page={page} />
      <InsideHeader
        h1="Thank You"
        background={get(page, 'page_image.contentUrl')}
      />
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mx-auto py-5">
            <h3>{get(page, 'thank_you_content[0].header')}</h3>
            <p>{get(page, 'thank_you_content[0].copy')}</p>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}

ThankYou.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'contact_us',
})(ThankYou);



// WEBPACK FOOTER //
// ./src/pages/ContactUs/ThankYou.js